exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small.amp[data-v-97b33d24]{width:1.25rem;height:.9375rem}.small.podcast[data-v-97b33d24]{width:.8125rem;height:1.125rem}.small.video[data-v-97b33d24]{width:1.125rem;height:1.125rem}span[data-v-97b33d24]{width:4.125rem;height:4.125rem;z-index:3;position:absolute}span>.icon[data-v-97b33d24]{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-97b33d24","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"/app/assets/scss/global/global.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/article-levels/IconIndicator.vue
// module id = 1730
// module chunks = 27